import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_gd5u95kt4s: FaireCollectionEntity = {
  token: "pbc_gd5u95kt4s",
  type: "collection",
  name: "kitchen",
  heroImageUrl:
    "https://cdn.faire.com/fastly/84b83d698f029bf84597ffe3ffda7c504dcf2eacb94ed4e9001075bb4089e620.jpeg",
  itemCount: 29,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:23.922Z",
    importedBy: "entity-db-import-collections",
  },
};
